import React from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AlertConfig } from '@/models/AlertModel.ts';
import { AlertMeasurementSettings } from '@/pages/patient-settings/alert-settings/conditions/AlertMeasurementSettings.tsx';
import { AlertTransmissionSettings } from '@/pages/patient-settings/alert-settings/conditions/AlertTransmissionSettings.tsx';

import { AlertHyperglycemiaBGMSettings } from './conditions/AlertHyperglycemiaBGMSettings';
import { AlertHyperglycemiaCGMSettings } from './conditions/AlertHyperglycemiaCGMSettings';
import { AlertHyperglycemiaTarSettings } from './conditions/AlertHyperglycemiaTarSettings';
import { AlertHypoglycemiaBGMSettings } from './conditions/AlertHypoglycemiaBGMSettings';
import { AlertHypoglycemiaCGMSettings } from './conditions/AlertHypoglycemiaCGMSettings';
import { AlertHypoglycemiaTbrSettings } from './conditions/AlertHypoglycemiaTbrSettings';
import { AlertTimeInRangeSettings } from './conditions/AlertTimeInRangeSettings';

export type AlertSettingsConditionsProps = {
  patientId: string;
  alertConfig: AlertConfig;
};

export const AlertSettingsConditions: React.FC<
  AlertSettingsConditionsProps
> = ({ alertConfig, patientId }) => {
  const { t } = useTranslation();

  if (alertConfig.type == 'bgm') {
    switch (alertConfig.category) {
      case 'hypoglycemia':
        return (
          <AlertHypoglycemiaBGMSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      case 'hyperglycemia':
        return (
          <AlertHyperglycemiaBGMSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
    }
  } else if (alertConfig.type == 'cgm') {
    switch (alertConfig.category) {
      case 'time_above_range':
        return (
          <AlertHyperglycemiaTarSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      case 'time_below_range':
        return (
          <AlertHypoglycemiaTbrSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      case 'time_in_range':
        return (
          <AlertTimeInRangeSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );

      case 'hypoglycemia':
        return (
          <AlertHypoglycemiaCGMSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      case 'hyperglycemia':
        return (
          <AlertHyperglycemiaCGMSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
    }
  } else if (alertConfig.type == 'other') {
    switch (alertConfig.category) {
      case 'observance_measures':
        return (
          <AlertMeasurementSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      case 'observance_transmission':
        return (
          <AlertTransmissionSettings
            patientId={patientId}
            alertConfig={alertConfig}
            parameters={alertConfig.parameters}
          />
        );
      default:
        return (
          <Typography variant="body">
            {t('alertConfig.notificationTriggeredAsSoonAsEventIsNoted')}
          </Typography>
        );
    }
  }

  return null;
};
